import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import once from 'lodash/once';

const InitializeI18n = (languagePreferenceOptions) => {
	i18n
		.use(Backend)
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			debug: false,
			ns: ['translation'],
			detection: languagePreferenceOptions,
			fallbackLng: 'en',
			backend: {
				loadPath: `/appactivation/locales/{{ns}}.{{lng}}.json`
			},
			interpolation: {
				escapeValue: false
			},
			react: {
				useSuspense: false
			}
		});
};

export async function InitializeReactI18n() {
	try {
		const languagePreferenceOptions = {
			order: ['cookie'],
			lookupCookie: 'paycorCulture'
		};

		let i18nInit = once(InitializeI18n);
		i18nInit(languagePreferenceOptions);
	} catch (error) {
		console.error(error);
	}
}

export function getTranslatedText(translate, key, defaultText) {
	return translate ? translate(key, defaultText) : defaultText;
}

